import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
import { FaSort } from "react-icons/fa";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const CourseReport = () => {
  const [courseData, setCourseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Sorting state

  const { data, startIndex, totalPageCount } = getPaginatedData(
    courseData,
    currentPage
  );

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/course-report`);
        setCourseData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching course report:", error.message);
      }
    };

    fetchReportData();
  }, []);


  // Sorting handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Sorted data
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return courseData;
    const sorted = [...courseData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle numeric sorting
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
    return sorted;
  }, [courseData, sortConfig]);

  // Helper to render sort icons
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="text-gray-400" />;
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Detail Report For Courses</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="page-data-new">
        {data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {!data?.length ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th

                  onClick={() => handleSort("Sno")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    S.no {renderSortIcon("Sno")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("CourseID")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Course Id {renderSortIcon("CourseID")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("CourseName")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Course Name {renderSortIcon("CourseName")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Category")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Category {renderSortIcon("Category")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("EnrollmentFee")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Enrollment Fee {renderSortIcon("EnrollmentFee")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Language")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Language {renderSortIcon("Language")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("courseViews")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Course Views {renderSortIcon("courseViews")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Sold")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Sold {renderSortIcon("Sold")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("BundleSale")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Bundle Sale {renderSortIcon("BundleSale")}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">
                      {currentPage * 10 - 10 + index + 1}
                    </td>
                    <td className="cell">{ele?.CourseID}</td>
                    <td className="cell">{ele?.CourseName}</td>
                    <td className="cell">
                      {ele?.Category === null ? "-" : ele?.Category}
                    </td>
                    <td className="cell">{ele?.EnrollmentFee}</td>
                    <td className="cell">{ele?.Language}</td>
                    <td className="cell">{ele?.courseViews}</td>
                    <td className="cell">{ele?.Sold}</td>
                    <td className="cell">{ele?.BundleSale}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className="pageNumbers-sudents">
        <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default CourseReport;
